import { UnavailableLimit } from './UnavailableLimit';
import {
  SpendingLimitEntry,
  TSpendingLimitType,
} from '../../../hooks/useGetSpendingLimits';
import { formatCurrency } from '../../../utils/currency';
import { formatDuration } from '../../SpendingLimitCard/components/duration.helpers';

const ALL_LIMIT_TYPES: TSpendingLimitType[] = ['THREE_MONTHS', 'TWELVE_MONTHS'];

export const ValidLimitDrawer = ({
  spendingLimits,
}: {
  spendingLimits: { isValid: boolean; limits: SpendingLimitEntry[] };
}) => {
  const hasThirtyDaysLimit = spendingLimits.limits.some(
    (l) => l.duration === 'THIRTY_DAYS',
  );

  const durationToMonths: Record<TSpendingLimitType, number> = {
    THIRTY_DAYS: 1,
    THREE_MONTHS: 3,
    TWELVE_MONTHS: 12,
  };

  return (
    <>
      <div className="mb-l flex flex-col gap-l">
        {ALL_LIMIT_TYPES.map((limitType) => {
          const spendingLimit = spendingLimits.limits.find(
            (l) => l.duration === limitType,
          );

          if (!spendingLimit) {
            return (
              <UnavailableLimit sellerProduct={limitType} key={limitType} />
            );
          }

          return (
            <div key={limitType}>
              <div className="mb-m text-m">
                {formatDuration({
                  duration: durationToMonths[spendingLimit.duration],
                  groupSameLimits: hasThirtyDaysLimit,
                })}{' '}
                purchases
              </div>
              <div className="mb-xs text-xs font-reg">Left to spend:</div>
              <div className="mb-s flex items-start gap-2xs">
                <span className="text-xl">
                  {formatCurrency(spendingLimit.availableAmount)}
                </span>
              </div>
              <div className="mb-xs text-xs">
                {(spendingLimit.interestRate * 100).toFixed(2)}%/month or
                interest-free**
              </div>
              <div className="text-xs font-reg">
                Limit: {formatCurrency(spendingLimit.maxAmount)}
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex flex-col gap-l border-t border-structure-80 pt-l text-xs font-reg">
        <div>
          *Your spending limits are subject to approval and reassessed every 30
          days &mdash; if something changes with your business the amounts might
          change.
        </div>
        <div>**Interest-free is offered by some of our suppliers.</div>
      </div>
    </>
  );
};
